const STATUS_RANK = { Booked: 0, "In Transit": 1, Delivered: 2, Invoiced: 3 };
const DAY_MS = 24 * 60 * 60 * 1000;

const includesText = (value, query) => String(value || "").toLowerCase().includes(query);
const timeValue = (isoValue) => (isoValue ? new Date(isoValue).getTime() : null);

const compareNullable = (left, right, desc) => {
  if (left == null && right == null) return 0;
  if (left == null) return desc ? -1 : 1;
  if (right == null) return desc ? 1 : -1;
  const result = left < right ? -1 : left > right ? 1 : 0;
  return desc ? -result : result;
};

export const filterBoardRows = (rows, { search, filters }) => {
  const query = (search || "").trim().toLowerCase();
  const status = filters.status || "";
  const startDate = filters.start_date ? new Date(`${filters.start_date}T00:00:00Z`).getTime() : null;
  const endDate = filters.end_date ? new Date(`${filters.end_date}T00:00:00Z`).getTime() + DAY_MS : null;
  return rows.filter((row) => {
    if (row.status === "Invoiced" || row.status === "Delivered") return false;
    if (status && row.dispatch_status !== status) return false;
    if (filters.customer_id && row.parent_load?.customer_id !== filters.customer_id) return false;
    if (filters.driver_id && row.driver_id !== filters.driver_id) return false;
    if (filters.truck_id && row.truck_id !== filters.truck_id) return false;
    if (filters.trailer_id && row.trailer_id !== filters.trailer_id) return false;
    if (query && ![row.trip_number, row.load_number, row.linked_load?.load_number, row.customer_name, row.pickup_company, row.pickup_city, row.delivery_company, row.delivery_city].some((value) => includesText(value, query))) return false;
    if (startDate != null) {
      const pickedAt = timeValue(row.pickup_datetime);
      if (pickedAt == null || pickedAt < startDate) return false;
    }
    if (endDate != null) {
      const deliveredAt = timeValue(row.delivery_datetime);
      if (deliveredAt == null || deliveredAt > endDate) return false;
    }
    return true;
  });
};

export const sortBoardRows = (rows, sortBy, sortDir) => {
  const desc = sortDir === "desc";
  const comparators = {
    load_number: (left, right) => compareNullable(left.trip_number, right.trip_number, desc),
    customer: (left, right) => compareNullable(left.customer_name, right.customer_name, desc),
    pickup_datetime: (left, right) => compareNullable(timeValue(left.pickup_datetime), timeValue(right.pickup_datetime), desc),
    delivery_datetime: (left, right) => compareNullable(timeValue(left.delivery_datetime), timeValue(right.delivery_datetime), desc),
    status: (left, right) => compareNullable(STATUS_RANK[left.status], STATUS_RANK[right.status], desc) || compareNullable(left.trip_number, right.trip_number, desc),
  };
  const comparator = comparators[sortBy] || comparators.pickup_datetime;
  return [...rows].sort(comparator);
};

export const queryBoardRows = (rows, { search, filters, page, pageSize }) => {
  const filtered = sortBoardRows(filterBoardRows(rows, { search, filters }), filters.sort_by, filters.sort_dir);
  const start = (page - 1) * pageSize;
  return { items: filtered.slice(start, start + pageSize), total_items: filtered.length };
};
